import { getRuntimeOrg } from '@/utils/runtimeOrg';

const ORG_ENV = (process.env.NEXT_PUBLIC_ORG || '').trim();
const BASE_ENV = (process.env.NEXT_PUBLIC_BASE_PATH || '').trim();

function cleanSlash(s: string) {
  return s.replace(/\/{2,}/g, '/');
}

function trimEdges(s: string) {
  return s.replace(/^\/+/, '').replace(/\/+$/, '');
}

function normalizeOrg(org?: string) {
  const o = (org || ORG_ENV || '').toLowerCase().trim();

  return o || undefined;
}

function getBasePath(): string {
  if (!BASE_ENV || BASE_ENV === '/') return '';

  return '/' + trimEdges(BASE_ENV);
}

function joinUrl(...parts: Array<string | undefined>): string {
  const filtered = parts.filter(Boolean) as string[];

  if (filtered.length === 0) return '/';
  const first = filtered[0].startsWith('/') ? filtered[0] : '/' + filtered[0];
  const rest = filtered.slice(1).map((p) => trimEdges(p));

  return cleanSlash([first, ...rest].join('/'));
}

export function imageSrc(path: string, org?: string): string {
  const o = normalizeOrg(org) || getRuntimeOrg();
  const p = trimEdges(path);
  const withOrg = p.startsWith(`${o}/`) ? p : `${o}/${p}`;

  return '/' + cleanSlash(withOrg);
}

export function asset(path: string, org?: string): string {
  const o = normalizeOrg(org) || getRuntimeOrg();
  const p = trimEdges(path);
  const withOrg = p.startsWith(`${o}/`) ? p : `${o}/${p}`;

  return joinUrl(getBasePath(), withOrg);
}
